import cookie from './cookie'
import {
    mapActions
} from 'vuex'

const COOKIE_DEFAULT_OBJECT = {
    strict: true,
    functional: true,
    analytics: null,
    userPreferences: null,
    marketing: null
}
const COOKIE_SETTING_NAME = `ubs_cookie_settings_${process.env.VUE_APP_COOKIES_VERSION}`
const COOKIE_SETTINGS_CONFIG = {
    STRICT: 0,
    FUNCTIONAL: 1,
    USER_PREFERENCE: 2,
    ANALYTICS: 3,
    MARKETING: 4
}
export default {
    mixins: [
        cookie
    ],
    methods: {
        ...mapActions('app', {
            setAppState: 'set'
        }),
        initCookieSettings() {
            const cookieSettings = this.getPrivacySettings()
            this.setAppState({
                cookieSettings: cookieSettings
            })
        },
        getPrivacySettings() {
            const cookieSettings = this.getCookie(COOKIE_SETTING_NAME)

            return cookieSettings ? Object.assign(COOKIE_DEFAULT_OBJECT, {
                analytics: cookieSettings.indexOf(COOKIE_SETTINGS_CONFIG.ANALYTICS) > 0,
                userPreferences: cookieSettings.indexOf(COOKIE_SETTINGS_CONFIG.USER_PREFERENCE) > 0,
                marketing: cookieSettings.indexOf(COOKIE_SETTINGS_CONFIG.MARKETING) > 0
            }) : COOKIE_DEFAULT_OBJECT
        },
        getContents(path) {
            return new Promise(function(resolve, reject) {
                var xhr = new XMLHttpRequest()
                xhr.open('get', path)
                xhr.onload = function() {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        resolve(xhr.response)
                    } else {
                        reject(new Error('fetch error'))
                    }
                }
                xhr.onerror = function() {
                    reject(new Error('fetch error'))
                }
                xhr.send()
            })
        }
    }
}
